(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-runtime"]) return;
  try {
    
(function (root) {
    'use strict';
    var VERSION = '1.1.1';
    var CONSENT_COPY_VERSION = 'HH-ESC01-CONSENT-V1';
    var DEFAULTS = {
        emailInvalid: 'Enter a valid email address.',
        nameInvalid: 'Use 80 characters or fewer.',
        consentRequired: 'Tick the updates consent box.',
        previewNotice: 'LOCAL TEST · NOTHING IS SENT.',
        previewPending: 'TESTING… NOTHING IS SENT.',
        previewError: 'SIMULATED ERROR · PLEASE RETRY.',
        previewSuccess: 'TEST PASSED · NOT REGISTERED.',
        previewDuplicate: 'ALREADY TESTED · NOT REGISTERED.',
        previewConfirmation: 'SIMULATED CONFIRMATION PENDING · NOT REGISTERED.',
        previewConfirmed: 'SIMULATED CONFIRMATION COMPLETE · NOT REGISTERED.',
        previewWithdrawn: 'SIMULATED WITHDRAWAL · NO REAL SUBSCRIPTION CHANGED.',
        previewFailed: 'TEST FAILED · PLEASE RETRY.',
        buttonIdle: 'LEAVE A SIGNAL',
        buttonPending: 'TESTING…',
        buttonRetry: 'TRY AGAIN',
        nativePending: 'SUBMITTING…',
        nativeClosed: 'Public sign-up is not open. Nothing has been saved.',
        buttonSubmitting: 'SUBMITTING…'
    };
    function strings(overrides) {
        var result = Object.assign({}, DEFAULTS);
        Object.keys(DEFAULTS).forEach(function (key) {
            if (overrides && typeof overrides[key] === 'string' && overrides[key].trim())
                result[key] = overrides[key];
        });
        return result;
    }
    function normalizeValues(values) {
        values = values || {};
        return {
            email: typeof values.email === 'string' ? values.email : '',
            firstName: typeof values.firstName === 'string' ? values.firstName : '',
            consent: values.consent === true
        };
    }
    function validateSignup(values, copy) {
        values = normalizeValues(values);
        copy = strings(copy);
        var email = values.email.trim();
        if (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
            return { field: 'email', message: copy.emailInvalid };
        if (values.firstName.trim().length > 80)
            return { field: 'firstName', message: copy.nameInvalid };
        if (!values.consent)
            return { field: 'consent', message: copy.consentRequired };
    }
    function anchorId(hash, mobile) {
        if (!hash || hash === '#')
            return '';
        var name;
        try {
            name = decodeURIComponent(hash.replace(/^#/, ''));
        }
        catch (_) {
            return '';
        }
        name = name.replace(/^crisp-/, '');
        if (name === 'top-mobile')
            name = 'top';
        return mobile ? (name === 'top' ? 'top-mobile' : name) : 'crisp-' + name;
    }
    function navigationUrl(href, currentHref) {
        var current = new URL(currentHref);
        var destination = new URL(href, current.href);
        if (destination.origin === current.origin && !destination.searchParams.has('preview_theme_id')) {
            current.searchParams.getAll('preview_theme_id').forEach(function (value) { destination.searchParams.append('preview_theme_id', value); });
        }
        return destination;
    }
    function sameDocumentRoute(destination, current) {
        return destination.origin === current.origin && destination.pathname === current.pathname &&
            JSON.stringify(destination.searchParams.getAll('view')) === JSON.stringify(current.searchParams.getAll('view')) &&
            JSON.stringify(destination.searchParams.getAll('preview_theme_id')) === JSON.stringify(current.searchParams.getAll('preview_theme_id'));
    }
    function createSignupPreview(options) {
        options = options || {};
        var copy = strings(options.strings);
        var wait = options.wait || function () { return new Promise(function (resolve) { root.setTimeout(resolve, 650); }); };
        var snapshot = { values: normalizeValues(), phase: 'idle', message: copy.previewNotice };
        var listeners = new Set();
        var receipts = new Map();
        var clock = options.clock || function () { return new Date().toISOString(); };
        var explicitConsentFor = null;
        var failedOnce = new Set();
        var forceErrorAvailable = options.forceError === true;
        function publish(next) { snapshot = next; listeners.forEach(function (listener) { listener(); }); }
        function key(email) { return typeof email === 'string' ? email.trim().toLowerCase() : ''; }
        function receiptCopy(email) { var receipt = receipts.get(key(email)); return receipt ? Object.assign({}, receipt) : null; }
        function demoTime() { return new Date(clock()).toISOString(); }
        function result(values, phase, message) {
            publish({ values: values, phase: phase, message: message, simulatedReceipt: receiptCopy(values.email) });
        }
        return {
            getSnapshot: function () { return snapshot; },
            getSimulatedReceipt: receiptCopy,
            getSimulatedEligibleReceipts: function () {
                return Array.from(receipts.values()).filter(function (receipt) { return receipt.state === 'confirmed'; }).map(function (receipt) { return Object.assign({}, receipt); });
            },
            simulateConfirmation: function (email) {
                var receipt = receipts.get(key(email));
                if (snapshot.phase === 'pending' || !receipt || receipt.state !== 'pending_confirmation')
                    return false;
                var time = demoTime();
                receipts.set(key(email), Object.assign({}, receipt, { state: 'confirmed', confirmedAt: time, updatedAt: time }));
                if (key(snapshot.values.email) === key(email))
                    result(snapshot.values, 'confirmed', copy.previewConfirmed);
                return true;
            },
            simulateWithdrawal: function (email) {
                var receipt = receipts.get(key(email));
                if (snapshot.phase === 'pending' || !receipt || receipt.state === 'withdrawn')
                    return false;
                var time = demoTime();
                receipts.set(key(email), Object.assign({}, receipt, { state: 'withdrawn', withdrawnAt: time, updatedAt: time }));
                if (explicitConsentFor === key(email))
                    explicitConsentFor = null;
                if (key(snapshot.values.email) === key(email))
                    result(Object.assign({}, snapshot.values, { consent: false }), 'withdrawn', copy.previewWithdrawn);
                return true;
            },
            subscribe: function (listener) { listeners.add(listener); return function () { listeners.delete(listener); }; },
            setField: function (field, value) {
                if (snapshot.phase === 'pending' || ['email', 'firstName', 'consent'].indexOf(field) === -1)
                    return;
                if (field === 'email' && key(value) !== key(snapshot.values.email))
                    explicitConsentFor = null;
                if (field === 'consent') {
                    if (value === true && snapshot.values.consent !== true)
                        explicitConsentFor = key(snapshot.values.email);
                    else if (value !== true)
                        explicitConsentFor = null;
                }
                var next = Object.assign({}, snapshot.values);
                next[field] = value;
                publish({ values: normalizeValues(next), phase: 'idle', message: copy.previewNotice });
            },
            submit: async function (submittedValues) {
                if (snapshot.phase === 'pending')
                    return;
                var input = submittedValues ? normalizeValues(submittedValues) : snapshot.values;
                var problem = validateSignup(input, copy);
                if (problem) {
                    publish({ values: input, phase: 'invalid', invalidField: problem.field, message: problem.message });
                    return;
                }
                var values = { email: input.email.trim().toLowerCase(), firstName: input.firstName.trim(), consent: true };
                publish({ values: values, phase: 'pending', message: copy.previewPending });
                try {
                    await wait();
                    if (forceErrorAvailable || (values.email === 'retry@example.test' && !failedOnce.has(values.email))) {
                        forceErrorAvailable = false;
                        failedOnce.add(values.email);
                        publish({ values: values, phase: 'error', message: copy.previewError });
                    }
                    else {
                        var previous = receipts.get(values.email);
                        var renewed = explicitConsentFor === values.email;
                        if (!previous || renewed) {
                            var time = demoTime();
                            var confirmationNeeded = options.confirmationRequired === true;
                            receipts.set(values.email, {
                                email: values.email, firstName: values.firstName || null,
                                consentCopyVersion: CONSENT_COPY_VERSION, consentedAt: time,
                                createdAt: previous ? previous.createdAt : time, updatedAt: time,
                                state: confirmationNeeded ? 'pending_confirmation' : 'confirmed',
                                confirmedAt: confirmationNeeded ? null : time, withdrawnAt: null,
                                simulationOnly: true, actualDeliveryAllowed: false, timestampEvidence: 'demo-clock-not-backend-evidence'
                            });
                        }
                        explicitConsentFor = null;
                        var receipt = receipts.get(values.email);
                        if (receipt.state === 'withdrawn')
                            result(Object.assign({}, values, { consent: false }), 'withdrawn', copy.previewWithdrawn);
                        else if (receipt.state === 'pending_confirmation')
                            result(values, 'confirmation', copy.previewConfirmation);
                        else
                            result(values, previous ? 'duplicate' : 'success', previous ? copy.previewDuplicate : copy.previewSuccess);
                    }
                }
                catch (_) {
                    publish({ values: values, phase: 'error', message: copy.previewFailed });
                }
            }
        };
    }
    var api = { version: VERSION, consentCopyVersion: CONSENT_COPY_VERSION, strings: strings, normalizeValues: normalizeValues, validateSignup: validateSignup, anchorId: anchorId, navigationUrl: navigationUrl, sameDocumentRoute: sameDocumentRoute, createSignupPreview: createSignupPreview };
    if (typeof module !== 'undefined' && module.exports)
        module.exports = api;
    if (!root || !root.document)
        return;
    if (root.HH_RUNTIME && root.HH_RUNTIME.version === VERSION) {
        root.HH_RUNTIME.hydrate();
        return;
    }
    var doc = root.document;
    var copy = strings(root.HH_STRINGS);
    var previewScenario = new URL(root.location.href).searchParams.get('signupPreview');
    var preview = createSignupPreview({ strings: copy, forceError: previewScenario === 'error', confirmationRequired: previewScenario === 'confirmation' });
    var previewForms = new Set();
    var nativeForms = new Set();
    var boundForms = new WeakSet();
    var boundMenus = new WeakSet();
    var inkObservers = new Map();
    var activeMenu = null;
    var nativeBusy = false;
    var nativeAttempt = 0;
    var nativeRestore = [];
    var nativeReturnedValuesSynced = false;
    var nativeServerErrorFocused = false;
    var nativeServerErrorFocusScheduled = false;
    var mobileQuery = root.matchMedia('(max-width: 767px)');
    function each(nodes, fn) { Array.prototype.forEach.call(nodes, fn); }
    function connectedSet(set) {
        set.forEach(function (node) { if (!node.isConnected)
            set.delete(node); });
        return set;
    }
    function field(form, name) {
        var names = { email: ['email', 'contact[email]'], firstName: ['firstName', 'contact[first_name]'], consent: ['consent', 'contact[accepts_marketing]'] };
        var explicit = form.querySelector('[data-hh-field="' + name + '"]');
        if (explicit)
            return explicit;
        for (var i = 0; i < names[name].length; i += 1) {
            var candidate = form.elements.namedItem(names[name][i]);
            if (candidate && candidate.tagName)
                return candidate;
            if (candidate && candidate.length) {
                for (var j = 0; j < candidate.length; j += 1)
                    if (candidate[j].type !== 'hidden')
                        return candidate[j];
            }
        }
        return null;
    }
    function valuesOf(form) {
        var email = field(form, 'email');
        var name = field(form, 'firstName');
        var consent = field(form, 'consent');
        return { email: email ? email.value : '', firstName: name ? name.value : '', consent: !!(consent && consent.checked) };
    }
    function status(form, message, invalidField) {
        var feedback = form.querySelector('[data-hh-feedback], [role="status"]');
        if (feedback) {
            feedback.textContent = message;
            feedback.setAttribute('aria-live', invalidField ? 'assertive' : 'polite');
            feedback.setAttribute('aria-atomic', 'true');
        }
        ['email', 'firstName', 'consent'].forEach(function (name) {
            var input = field(form, name);
            if (!input)
                return;
            if (name === invalidField)
                input.setAttribute('aria-invalid', 'true');
            else
                input.removeAttribute('aria-invalid');
        });
    }
    function focusProblem(form, problem) {
        var input = problem && field(form, problem.field);
        if (input)
            input.focus();
    }
    function nativeReady(form) { return form.getAttribute('data-hh-ready') === 'true'; }
    function unlock(form) {
        if (form.getAttribute('data-hh-signup') !== 'preview' && !nativeReady(form))
            return;
        ['email', 'firstName', 'consent'].forEach(function (name) {
            var input = field(form, name);
            if (input) {
                input.disabled = false;
                input.readOnly = false;
            }
        });
        each(form.querySelectorAll('button[type="submit"], input[type="submit"]'), function (button) { button.disabled = false; });
    }
    function buttonCopy(button, text) {
        if (button.tagName === 'INPUT')
            button.value = text;
        else
            button.textContent = text;
    }
    function renderPreview() {
        var snapshot = preview.getSnapshot();
        var busy = snapshot.phase === 'pending';
        connectedSet(previewForms).forEach(function (form) {
            form.setAttribute('aria-busy', String(busy));
            form.setAttribute('data-hh-state', snapshot.phase);
            ['email', 'firstName', 'consent'].forEach(function (name) {
                var input = field(form, name);
                if (!input)
                    return;
                if (name === 'consent')
                    input.checked = snapshot.values.consent;
                else if (input.value !== snapshot.values[name])
                    input.value = snapshot.values[name];
                input.disabled = busy;
            });
            each(form.querySelectorAll('button[type="submit"], input[type="submit"]'), function (button) {
                button.disabled = busy;
                buttonCopy(button, busy ? copy.buttonPending : snapshot.phase === 'error' ? copy.buttonRetry : copy.buttonIdle);
            });
            status(form, snapshot.message, snapshot.invalidField || (snapshot.phase === 'error' ? '__error' : undefined));
        });
    }
    preview.subscribe(renderPreview);
    function syncNativeValues(source) {
        if (nativeBusy)
            return;
        var values = valuesOf(source);
        connectedSet(nativeForms).forEach(function (form) {
            if (!nativeReady(form))
                return;
            ['email', 'firstName', 'consent'].forEach(function (name) {
                var input = field(form, name);
                if (!input)
                    return;
                if (name === 'consent')
                    input.checked = values.consent;
                else if (input.value !== values[name])
                    input.value = values[name];
                input.removeAttribute('aria-invalid');
            });
        });
    }
    function visible(element) {
        return element.isConnected && !element.hidden && element.getClientRects().length > 0 && root.getComputedStyle(element).visibility !== 'hidden';
    }
    function nativeServerState(form) {
        var marker = form.querySelector('[data-hh-server-result]');
        var value = marker && marker.getAttribute('data-hh-server-result');
        return ['idle', 'received', 'error'].indexOf(value) !== -1 ? value : 'idle';
    }
    function syncNativeServerState() {
        if (nativeBusy)
            return;
        var forms = Array.from(connectedSet(nativeForms)).filter(nativeReady);
        forms.forEach(function (form) { form.setAttribute('data-hh-state', nativeServerState(form)); });
        if (!nativeReturnedValuesSynced) {
            var returned = forms.find(function (form) { return nativeServerState(form) !== 'idle' && valuesOf(form).email.trim(); });
            if (returned) {
                syncNativeValues(returned);
                nativeReturnedValuesSynced = true;
            }
        }
        if (nativeServerErrorFocused || nativeServerErrorFocusScheduled)
            return;
        nativeServerErrorFocusScheduled = true;
        Promise.resolve().then(function () {
            nativeServerErrorFocusScheduled = false;
            if (nativeBusy || nativeServerErrorFocused)
                return;
            var errorForm = Array.from(connectedSet(nativeForms)).find(function (form) { return nativeReady(form) && nativeServerState(form) === 'error' && visible(form); });
            if (!errorForm)
                return;
            var feedback = errorForm.querySelector('[data-hh-feedback], [role="status"]');
            if (feedback && visible(feedback)) {
                feedback.setAttribute('tabindex', '-1');
                feedback.setAttribute('aria-live', 'assertive');
                feedback.focus();
                nativeServerErrorFocused = true;
            }
        });
    }
    function restoreNativeSubmit() {
        nativeRestore.forEach(function (restore) { restore(); });
        nativeRestore = [];
        nativeBusy = false;
    }
    function beginNativeSubmit() {
        nativeBusy = true;
        nativeAttempt += 1;
        connectedSet(nativeForms).forEach(function (form) {
            if (!nativeReady(form))
                return;
            var feedback = form.querySelector('[data-hh-feedback], [role="status"]');
            var message = feedback ? feedback.textContent : '';
            nativeRestore.push(function () { form.setAttribute('aria-busy', 'false'); status(form, message); });
            form.setAttribute('aria-busy', 'true');
            status(form, copy.nativePending);
            ['email', 'firstName'].forEach(function (name) {
                var input = field(form, name);
                if (!input)
                    return;
                var before = input.readOnly;
                nativeRestore.push(function () { input.readOnly = before; });
                input.readOnly = true;
            });
            each(form.querySelectorAll('button[type="submit"], input[type="submit"]'), function (button) {
                var before = button.disabled;
                var text = button.tagName === 'INPUT' ? button.value : button.textContent;
                nativeRestore.push(function () { button.disabled = before; buttonCopy(button, text); });
                button.disabled = true;
                buttonCopy(button, copy.buttonSubmitting);
            });
        });
        return nativeAttempt;
    }
    function bindForm(form) {
        var mode = form.getAttribute('data-hh-signup');
        if (mode !== 'preview' && mode !== 'shopify')
            return;
        if (mode === 'preview')
            previewForms.add(form);
        else
            nativeForms.add(form);
        if (boundForms.has(form))
            return;
        boundForms.add(form);
        unlock(form);
        function onInput(event) {
            var name = ['email', 'firstName', 'consent'].find(function (key) { return field(form, key) === event.target; });
            if (!name)
                return;
            if (mode === 'preview')
                preview.setField(name, name === 'consent' ? event.target.checked : event.target.value);
            else if (nativeReady(form))
                syncNativeValues(form);
        }
        form.addEventListener('input', onInput);
        form.addEventListener('change', onInput);
        form.addEventListener('submit', function (event) {
            if (mode === 'preview') {
                event.preventDefault();
                if (preview.getSnapshot().phase === 'pending')
                    return;
                var values = valuesOf(form);
                var problem = validateSignup(values, copy);
                void preview.submit(values);
                focusProblem(form, problem);
                return;
            }
            if (!nativeReady(form) || nativeBusy) {
                event.preventDefault();
                if (!nativeReady(form))
                    status(form, copy.nativeClosed, '__error');
                return;
            }
            var nativeValues = valuesOf(form);
            var nativeProblem = validateSignup(nativeValues, copy);
            if (nativeProblem) {
                event.preventDefault();
                connectedSet(nativeForms).forEach(function (other) { status(other, nativeProblem.message, nativeProblem.field); });
                focusProblem(form, nativeProblem);
                return;
            }
            if (event.defaultPrevented)
                return;
            field(form, 'email').value = nativeValues.email.trim().toLowerCase();
            var firstName = field(form, 'firstName');
            if (firstName)
                firstName.value = nativeValues.firstName.trim();
            var attempt = beginNativeSubmit();
            root.setTimeout(function () { if (event.defaultPrevented && nativeAttempt === attempt)
                restoreNativeSubmit(); }, 0);
        });
    }
    function fitInk(outer) {
        if (!outer.isConnected || !outer.offsetWidth)
            return;
        var inner = outer.firstElementChild;
        if (!inner)
            return;
        var ctx = doc.createElement('canvas').getContext('2d');
        if (!ctx)
            return;
        var font = root.getComputedStyle(inner);
        var px = parseFloat(font.fontSize);
        ctx.font = font.fontWeight + ' ' + px + 'px ' + font.fontFamily;
        var m = ctx.measureText(inner.textContent);
        var aw = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
        var ah = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
        var fa = m.fontBoundingBoxAscent == null ? px * 0.9 : m.fontBoundingBoxAscent;
        var fd = m.fontBoundingBoxDescent == null ? px * 0.2 : m.fontBoundingBoxDescent;
        var inkTop = (px - fa - fd) / 2 + fa - m.actualBoundingBoxAscent;
        var bounds = outer.getBoundingClientRect();
        if (aw && ah)
            inner.style.transform = 'scale(' + bounds.width / aw + ', ' + bounds.height / ah + ') translate(' + m.actualBoundingBoxLeft + 'px, ' + -inkTop + 'px)';
    }
    function fitAll() { inkObservers.forEach(function (_, outer) { fitInk(outer); }); }
    function observeInk(outer) {
        if (inkObservers.has(outer)) {
            fitInk(outer);
            return;
        }
        var observer = root.ResizeObserver ? new root.ResizeObserver(function () { fitInk(outer); }) : null;
        inkObservers.set(outer, observer);
        fitInk(outer);
        if (observer)
            observer.observe(outer);
    }
    function focusHash(hash) {
        var mobile = mobileQuery.matches;
        var id = anchorId(hash, mobile);
        var target = id ? doc.getElementById(id) : null;
        if (!target)
            return false;
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
        var focus = mobile ? target.querySelector('h1, h2') || target : target;
        focus.setAttribute('tabindex', '-1');
        focus.focus({ preventScroll: true });
        return true;
    }
    function syncHash() { if (root.location.hash)
        focusHash(root.location.hash); }
    function closeMenu(restoreFocus) {
        if (!activeMenu)
            return;
        var menu = activeMenu;
        activeMenu = null;
        menu.panel.hidden = true;
        menu.trigger.setAttribute('aria-expanded', 'false');
        doc.body.style.overflow = menu.previousOverflow;
        if (restoreFocus && menu.trigger.isConnected)
            menu.trigger.focus();
    }
    function openMenu(trigger, panel) {
        if (!mobileQuery.matches)
            return;
        if (activeMenu && activeMenu.trigger === trigger) {
            closeMenu(true);
            return;
        }
        closeMenu(false);
        activeMenu = { trigger: trigger, panel: panel, previousOverflow: doc.body.style.overflow };
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        doc.body.style.overflow = 'hidden';
        var first = panel.querySelector('button, a[href]');
        if (first)
            first.focus();
    }
    function bindMenu(trigger) {
        if (boundMenus.has(trigger))
            return;
        var nav = trigger.closest('.site-nav');
        var panel = nav && nav.querySelector('.mobile-nav');
        if (!panel)
            panel = doc.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel)
            return;
        boundMenus.add(trigger);
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', function () { openMenu(trigger, panel); });
        var close = panel.querySelector('.mobile-nav-close');
        if (close)
            close.addEventListener('click', function () { closeMenu(true); });
    }
    function preservePreviewLink(anchor) {
        if (anchor.hasAttribute('download'))
            return;
        var destination = navigationUrl(anchor.href, root.location.href);
        if (destination.href !== anchor.href)
            anchor.setAttribute('href', destination.href);
    }
    doc.addEventListener('keydown', function (event) {
        if (!activeMenu)
            return;
        if (event.key === 'Escape') {
            event.preventDefault();
            closeMenu(true);
            return;
        }
        if (event.key !== 'Tab')
            return;
        var controls = Array.from(activeMenu.panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(function (item) {
            return !item.disabled && !item.hidden && item.getAttribute('tabindex') !== '-1' && item.getClientRects().length;
        });
        if (!controls.length) {
            event.preventDefault();
            return;
        }
        var first = controls[0];
        var last = controls[controls.length - 1];
        if (event.shiftKey && (doc.activeElement === first || !activeMenu.panel.contains(doc.activeElement))) {
            event.preventDefault();
            last.focus();
        }
        else if (!event.shiftKey && (doc.activeElement === last || !activeMenu.panel.contains(doc.activeElement))) {
            event.preventDefault();
            first.focus();
        }
    });
    doc.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
            return;
        var element = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
        var anchor = element && element.closest('a[href]');
        if (!anchor || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self'))
            return;
        if (!anchor.closest('.hh-canvas, .live-responsive, .site-nav'))
            return;
        var current = new URL(root.location.href);
        var destination = navigationUrl(anchor.href, current.href);
        if (destination.href !== anchor.href)
            anchor.setAttribute('href', destination.href);
        if (activeMenu && activeMenu.panel.contains(anchor))
            closeMenu(false);
        if (!sameDocumentRoute(destination, current) || !destination.hash)
            return;
        if (!doc.getElementById(anchorId(destination.hash, mobileQuery.matches)))
            return;
        event.preventDefault();
        root.history.pushState(null, '', destination.href);
        focusHash(destination.hash);
    });
    root.addEventListener('hashchange', syncHash);
    root.addEventListener('popstate', syncHash);
    root.addEventListener('resize', fitAll);
    function breakpointChanged() { if (!mobileQuery.matches)
        closeMenu(false); fitAll(); syncHash(); syncNativeServerState(); }
    if (mobileQuery.addEventListener)
        mobileQuery.addEventListener('change', breakpointChanged);
    else
        mobileQuery.addListener(breakpointChanged);
    root.addEventListener('pageshow', function (event) {
        if (!event.persisted)
            return;
        restoreNativeSubmit();
        fitAll();
    });
    function hydrate() {
        if (activeMenu && (!activeMenu.panel.isConnected || !activeMenu.trigger.isConnected))
            closeMenu(false);
        inkObservers.forEach(function (observer, outer) {
            if (!outer.isConnected) {
                if (observer)
                    observer.disconnect();
                inkObservers.delete(outer);
            }
        });
        each(doc.querySelectorAll('.hh-ink'), observeInk);
        each(doc.querySelectorAll('.menu-trigger'), bindMenu);
        each(doc.querySelectorAll('.hh-canvas a[href], .live-responsive a[href], .site-nav a[href]'), preservePreviewLink);
        each(doc.querySelectorAll('form[data-hh-signup]'), bindForm);
        syncNativeServerState();
        renderPreview();
    }
    api.hydrate = hydrate;
    root.HH_RUNTIME = api;
    doc.addEventListener('shopify:section:load', hydrate);
    doc.addEventListener('shopify:section:unload', function () { root.setTimeout(hydrate, 0); });
    function start() {
        hydrate();
        syncHash();
        if (doc.fonts && doc.fonts.ready)
            doc.fonts.ready.then(function () { fitAll(); });
        if (doc.fonts && doc.fonts.addEventListener)
            doc.fonts.addEventListener('loadingdone', fitAll);
    }
    if (doc.readyState === 'loading')
        doc.addEventListener('DOMContentLoaded', start, { once: true });
    else
        start();
}(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-water-film"]) return;
  try {
    
(()=>{
const PRODUCT_OUTLINE = [
  [429,342.7],[433.7,342],[440.3,344.3],[462,352.7],
  [482,360.3],[490.3,362.7],[495,367.3],[498.7,375],
  [503.3,388],[507,402.3],[509,414.3],[508,422],
  [503.3,430.3],[496.3,442.3],[488,454.3],[480.3,466.7],
  [473.3,478],[468.7,482.7],[463.3,485],[457.7,485],
  [449,482],[439,478],[409,465],[390,455],[385,450],
  [382,443],[381.7,436],[384,424],[391,404],[395,393],
  [419,351],[424,345]
];

function productDistance(x,y){
  if(x<379||x>512||y<339||y>488)return 99;
  let inside=false,dist2=Infinity;
  for(let i=0,j=PRODUCT_OUTLINE.length-1;i<PRODUCT_OUTLINE.length;j=i++){
    const [ax,ay]=PRODUCT_OUTLINE[j],[bx,by]=PRODUCT_OUTLINE[i];
    if(((ay>y)!==(by>y))&&x<(bx-ax)*(y-ay)/(by-ay)+ax)inside=!inside;
    const dx=bx-ax,dy=by-ay,t=Math.max(0,Math.min(1,((x-ax)*dx+(y-ay)*dy)/(dx*dx+dy*dy)));
    dist2=Math.min(dist2,(x-ax-t*dx)**2+(y-ay-t*dy)**2);
  }
  return (inside?-1:1)*Math.sqrt(dist2);
}


const PAPER_EDGE = Object.freeze([
  [463.067,0], [463.4,1], [463.733,2], [464.067,3], [464.067,4], [464.067,5], [464.733,6], [466.4,7],
  [466.4,8], [466.4,9], [465.733,10], [465.4,11], [465.067,12], [464.733,13], [464.4,14], [462.067,15],
  [462.067,16], [462.067,17], [461.733,18], [464.733,19], [464.733,20], [465.067,21], [465.067,22], [465.4,23],
  [466.067,24], [466.4,25], [467.4,26], [467.4,27], [467.067,28], [466.4,29], [466.4,30], [467.067,31],
  [467.067,32], [467.067,33], [467.067,34], [467.067,35], [469.067,36], [469.4,37], [469.733,38], [470.067,39],
  [469.733,40], [469.733,41], [470.067,42], [470.4,43], [470.4,44], [470.067,45], [469.4,46], [469.4,47],
  [469.733,48], [469.733,49], [469.4,50], [468.733,51], [468.733,52], [468.4,53], [467.733,54], [467.4,55],
  [467.067,56], [467.4,57], [467.4,58], [467.733,59], [467.733,60], [467.4,61], [466.4,62], [465.4,63],
  [465.067,64], [464.733,65], [464.4,66], [464.4,67], [464.067,68], [463.733,69], [463.4,70], [463.067,71],
  [463.067,72], [463.067,73], [463.067,74], [463.067,75], [463.4,76], [463.733,77], [463.733,78], [464.067,79],
  [464.067,80], [463.733,81], [463.733,82], [463.4,83], [463.4,84], [463.067,85], [462.4,86], [462.067,87],
  [461.4,88], [460.733,89], [457.5,90], [457.4,91], [457.067,92], [456.733,93], [456.4,94], [456.4,95],
  [456.067,96], [456.067,97], [456.733,98], [456.733,99], [456.733,100], [457.067,101], [457.067,102], [457.4,103],
  [457.067,104], [456.733,105], [456.067,106], [455.4,107], [455.067,108], [455.067,109], [455.733,110], [456.067,111],
  [456.067,112], [455.4,113], [454.4,114], [453.733,115], [453.733,116], [453.733,117], [453.733,118], [453.4,119],
  [453.4,120], [453.4,121], [453.067,122], [453.067,123], [453.067,124], [453.067,125], [453.067,126], [453.067,127],
  [452.733,128], [452.733,129], [450.067,130], [452.733,131], [453.067,132], [453.4,133], [453.733,134], [454.067,135],
  [455.067,136], [455.733,137], [456.4,138], [456.4,139], [456.4,140], [456.733,141], [457.4,142], [457.4,143],
  [456.4,144], [456.067,145], [456.4,146], [457.4,147], [458.4,148], [458.733,149], [458.733,150], [458.4,151],
  [458.733,152], [458.4,153], [457.4,154], [457.4,155], [457.733,156], [457.733,157], [457.4,158], [457.067,159],
  [457.067,160], [457.067,161], [457.4,162], [458.067,163], [458.067,164], [457.733,165], [457.733,166], [458.4,167],
  [458.733,168], [458.733,169], [458.4,170], [458.4,171], [458.733,172], [459.4,173], [460.067,174], [460.733,175],
  [461.067,176], [460.733,177], [461.067,178], [461.733,179], [462.4,180], [462.733,181], [463.067,182], [463.067,183],
  [463.4,184], [462.733,185], [462.4,186], [462.4,187], [462.4,188], [462.4,189], [462.733,190], [462.4,191],
  [461.733,192], [461.067,193], [460.4,194], [460.4,195], [460.4,196], [460.4,197], [460.4,198], [460.067,199],
  [459.4,200], [458.733,201], [458.4,202], [458.733,203], [459.4,204], [459.4,205], [459.067,206], [457.733,207],
  [457.067,208], [456.733,209], [456.4,210], [456.4,211], [456.4,212], [456.733,213], [457.4,214], [458.067,215],
  [458.733,216], [458.733,217], [457.733,218], [457.067,219], [456.733,220], [457.067,221], [457.4,222], [458.067,223],
  [458.067,224], [457.733,225], [457.4,226], [457.4,227], [457.067,228], [457.067,229], [456.733,230], [456.4,231],
  [456.067,232], [455.4,233], [454.733,234], [454.4,235], [455.067,236], [455.733,237], [456.4,238], [456.4,239],
  [456.4,240], [456.067,241], [453.733,242], [453.733,243], [453.4,244], [453.067,245], [452.733,246], [452.733,247],
  [452.733,248], [453.067,249], [453.4,250], [453.067,251], [452.733,252], [452.4,253], [452.733,254], [453.067,255],
  [453.067,256], [452.733,257], [451.733,258], [451.067,259], [450.733,260], [450.733,261], [450.733,262], [451.067,263],
  [451.4,264], [452.067,265], [452.067,266], [451.733,267], [451.067,268], [450.733,269], [450.4,270], [450.4,271],
  [450.733,272], [451.4,273], [452.067,274], [452.4,275], [452.4,276], [452.067,277], [452.4,278], [452.733,279],
  [453.067,280], [453.4,281], [453.733,282], [454.4,283], [454.4,284], [454.4,285], [453.733,286], [453.4,287],
  [454.067,288], [454.733,289], [455.067,290], [455.067,291], [454.733,292], [454.4,293], [454.4,294], [455.067,295],
  [455.4,296], [456.067,297], [456.733,298], [457.4,299], [457.733,300], [457.067,301], [457.067,302], [457.4,303],
  [457.733,304], [457.4,305], [457.733,306], [458.067,307], [458.067,308], [458.067,309], [458.067,310], [458.4,311],
  [459.067,312], [459.4,313], [459.4,314], [459.4,315], [459.067,316], [458.733,317], [459.733,318], [460.067,319],
  [460.4,320], [460.733,321], [461.067,322], [461.067,323], [461.067,324], [461.067,325], [461.067,326], [460.733,327],
  [460.733,328], [460.4,329], [459.733,330], [460.4,331], [460.4,332], [460.4,333], [460.4,334], [460.733,335],
  [460.733,336], [461.067,337], [461.4,338], [461.4,339], [461.4,340], [461.4,341], [461.733,342], [461.4,343],
  [461.733,344], [461.733,345], [462.067,346], [462.4,347], [463.067,348], [463.733,349], [463.067,350], [462.4,351],
  [462.067,352], [462.4,353], [463.067,354], [463.067,486], [463.067,487], [463.4,488], [463.733,489], [462.733,490],
  [462.4,491], [462.4,492], [462.733,493], [462.4,494], [462.4,495], [462.733,496], [462.733,497], [462.733,498],
  [462.733,499], [462.4,500], [462.4,501], [462.4,502], [462.4,503], [462.4,504], [462.4,505], [462.4,506],
  [462.4,507], [462.067,508], [462.067,509], [462.067,510], [462.4,511], [462.4,512], [462.733,513], [463.733,514],
  [463.733,515], [463.067,516], [463.067,517], [462.733,518], [462.733,519], [462.733,520], [462.4,521], [462.4,522],
  [462.4,523], [462.4,524], [462.4,525], [462.4,526], [462.733,527], [462.733,528], [462.733,529], [462.733,530],
  [462.733,531], [462.733,532], [462.733,533], [463.067,534], [463.067,535], [462.733,536], [462.4,537], [462.733,538],
  [462.733,539], [462.733,540], [462.733,541], [462.733,542], [462.733,543], [462.733,544], [462.733,545], [462.733,546],
  [463.067,547], [463.733,548], [463.733,549], [463.733,550], [463.733,551], [463.733,552], [463.733,553], [463.733,554],
  [463.733,555], [463.733,556], [463.733,557],
].map(point => Object.freeze(point)));

const BOTTOM_EDGE = Object.freeze([
  [462,557], [463,557], [464,557], [465,557], [466,557], [467,556.667], [468,556.333], [469,556],
  [470,556], [471,556.667], [472,556.667], [473,556.667], [474,556.667], [475,556.667], [476,556.667], [477,556.667],
  [478,557], [479,557], [480,556.667], [481,556.333], [482,556], [483,556.667], [484,556.667], [485,555.667],
  [486,556.667], [487,556.667], [488,556], [489,556.667], [490,556.667], [491,556.667], [492,557], [493,557],
  [494,557], [495,557], [496,556.667], [497,556.667], [498,556.667], [499,556.667], [500,556.667], [501,557],
  [502,557], [503,557], [504,557], [505,557], [506,557], [507,557], [508,557], [509,556.667],
  [510,556.333], [511,556.667], [512,557], [513,557], [514,557], [515,556.667], [516,557], [517,557],
  [518,557], [519,556.667], [520,556.667], [521,556.667], [522,556.667], [523,556.667], [524,557], [525,557],
  [526,557], [527,557], [528,557], [529,557], [530,557], [531,557], [532,557], [533,557],
  [534,557], [535,556.667], [536,556.333], [537,556], [538,555.667], [539,555.333], [540,556], [541,556.333],
  [542,556.333], [543,556.667], [544,557], [545,556.667], [546,556.667], [547,556.667], [548,556.667], [549,556.333],
  [550,556], [551,555.333], [552,555.333], [553,556], [554,556.333], [555,556.333], [556,556.667], [557,557],
  [558,557], [559,557], [560,556.667], [561,556.667], [562,556.667], [563,556.333], [564,556.333], [565,556],
  [566,555.333], [567,555.667], [568,556], [569,556], [570,556.667], [571,557], [572,557], [573,557],
  [574,557], [575,557], [576,557], [577,557], [578,557], [579,557], [580,557], [581,557],
  [582,557], [583,557], [584,557], [585,557], [586,556.667], [587,556.667], [588,556.667], [589,556.333],
  [590,555.333], [591,555.333], [592,555.333], [593,555.333], [594,555.333], [595,555.333], [596,555.333], [597,555.333],
  [598,555.333], [599,555.667], [600,556], [601,556], [602,556.333], [603,557], [604,557], [605,557],
  [606,557], [607,556.333], [608,556.333], [609,556.333], [610,556], [611,555.667], [612,556], [613,556.333],
  [614,556], [615,556], [616,556], [617,556], [618,556.333], [619,556.333], [620,556.333], [621,556.667],
  [622,557], [623,557], [624,557], [625,556.333], [626,556], [627,556], [628,556], [629,556.333],
  [630,556.667], [631,557], [632,557], [633,556.333], [634,556], [635,556], [636,556], [637,556],
  [638,556], [639,556], [640,556], [641,556.333], [642,556], [643,556], [644,555.333], [645,555.667],
  [646,556.333], [647,556.333], [648,556], [649,555.667], [650,555.333], [651,555.333], [652,556.667], [653,556],
  [654,556], [655,556.333], [656,556], [657,555.667], [658,555.667], [659,556.667], [660,556.667], [661,556.667],
  [662,556.667], [663,556.667], [664,556.667], [665,556], [666,556], [667,556.333], [668,556.333], [669,556.333],
  [670,556.333], [671,557], [672,557], [673,557], [674,557], [675,557], [676,557], [677,557],
  [678,557], [679,557], [680,556.667], [681,555.333], [682,555.333], [683,555.333], [684,556], [685,556],
  [686,556.667], [687,557], [688,557], [689,557], [690,557], [691,557], [692,557], [693,557],
  [694,557], [695,557], [696,557], [697,557], [698,556.667], [699,556.667], [700,556.333], [701,556.333],
  [702,556], [703,556], [704,556], [705,556], [706,555.667], [707,555.333], [708,555.667], [709,556],
  [710,556], [711,556], [712,555.333], [713,555.333], [714,555.333], [715,555.333], [716,555.667], [717,555.667],
  [718,556], [719,556], [720,556.333], [721,556.667], [722,556.667], [723,556.333], [724,556], [725,556],
  [726,556], [727,556], [728,556], [729,556], [730,555.667], [731,555.333], [732,555.333], [733,556.667],
  [734,556.667], [735,556.667], [736,556.667], [737,556.667], [738,555.333], [739,555.333], [740,556.667], [741,556.667],
  [742,556], [743,556], [744,556], [745,556], [746,556], [747,555.667], [748,555.333], [749,556.667],
  [750,556.667], [751,556.667], [752,556.667], [753,556.667], [754,556.667], [755,556.667], [756,556], [757,556],
  [758,556], [759,556.333], [760,556.333], [761,556], [762,555.333], [763,556.667], [764,556.667], [765,556.667],
  [766,556.667], [767,557], [768,557], [769,557], [770,557], [771,557], [772,557], [773,557],
  [774,557], [775,557], [776,557], [777,556.667], [778,556.667], [779,556.667], [780,556.667], [781,556.667],
  [782,556.667], [783,557], [784,557], [785,557], [786,556.667], [787,556.667], [788,556.667], [789,557],
  [790,557], [791,557], [792,557], [793,557], [794,557], [795,557], [796,557], [797,557],
  [798,556.667], [799,557], [800,557], [801,557], [802,557], [803,556.667], [804,556.333], [805,556.333],
  [806,556.667], [807,557], [808,557], [809,557], [810,556.667], [811,556.667], [812,556.667], [813,556.667],
  [814,556.667], [815,557], [816,557], [817,557], [818,557], [819,557], [820,557], [821,557],
  [822,557], [823,557], [824,556.667], [825,556.333], [826,556.333], [827,556.333], [828,556.333], [829,556.667],
  [830,556.667], [831,556.667], [832,556.667], [833,556.333], [834,556.333], [835,556.333], [836,556.333], [837,557],
  [838,557], [839,557], [840,557], [841,557], [842,556.667], [843,556.667], [844,556.667], [845,556.667],
  [846,557], [847,557], [848,557], [849,557],
].map(point => Object.freeze(point)));


const REFERENCE={width:849,height:557,sha256:'683ef1556beb7d3a35df10dcf0d84d87c5b08575d1e647abf1a01271c4200d54'};
const FRAME_MAPPINGS=Object.freeze({
  original:Object.freeze({
    width:849,height:557,
    sourceRect:Object.freeze({x:0,y:0,width:849,height:557}),
    description:'Full approved 849:557 artwork, with no padding or crop.'
  }),
  'runway-padded-4x3':Object.freeze({
    width:2548,height:1911,
    sourceRect:Object.freeze({x:0,y:120,width:2547,height:1671}),
    description:'Known 4:3 transport: remove 120 source pixels above/below and one at the right; keep the approved 2547 x 1671 artwork.'
  })
});
const dimensionsValid=(width,height)=>Number.isSafeInteger(width)&&Number.isSafeInteger(height)&&width>0&&height>0;
function resolveFrameMapping(width,height,mapping='original'){
  if(!Object.hasOwn(FRAME_MAPPINGS,mapping))throw new Error('Unknown video mapping: '+mapping);
  if(!dimensionsValid(width,height))throw new Error('Frame not decoded or invalid dimensions');
  const definition=FRAME_MAPPINGS[mapping];
  if(width*definition.height!==height*definition.width)throw new Error('Video framing requires registration for mapping '+mapping);
  const scale=width/definition.width;
  return {
    mapping,
    description:definition.description,
    sourceRect:{
      x:definition.sourceRect.x*scale,
      y:definition.sourceRect.y*scale,
      width:definition.sourceRect.width*scale,
      height:definition.sourceRect.height*scale
    }
  };
}
const smooth=(a,b,v)=>{const t=Math.max(0,Math.min(1,(v-a)/(b-a)));return t*t*(3-2*t);};
function interpolate(points,v,axis){
  let low=0,high=points.length-1;
  if(v<=points[low][axis])return points[low][1-axis];
  if(v>=points[high][axis])return points[high][1-axis];
  while(high-low>1){const mid=(low+high)>>1;if(points[mid][axis]>v)high=mid;else low=mid;}
  const a=points[low],b=points[high],t=(v-a[axis])/(b[axis]-a[axis]);
  return a[1-axis]+t*(b[1-axis]-a[1-axis]);
}
function waterAlpha(x,y){
  if(x<0||y<0||x>=REFERENCE.width||y>=REFERENCE.height)return 0;
  const paperEdge=interpolate(PAPER_EDGE,y,1);
  if(x<=paperEdge)return 0;
  const bottomEdge=interpolate(BOTTOM_EDGE,x,0);
  if(y>=bottomEdge)return 0;
  return smooth(0,.65,x-paperEdge)
    *smooth(0,.65,bottomEdge-y)
    *smooth(0,.65,productDistance(x,y));
}
const alphaCache=new Map();
function alphaPixels(width,height){
  const key=width+'x'+height;
  if(alphaCache.has(key))return alphaCache.get(key);
  const alpha=new Uint8ClampedArray(width*height);
  for(let y=0;y<height;y++)for(let x=0;x<width;x++)alpha[y*width+x]=Math.round(waterAlpha((x+.5)*849/width,(y+.5)*557/height)*255);
  if(alphaCache.size>=2)alphaCache.clear();
  alphaCache.set(key,alpha);return alpha;
}
function auditProtectedPixels(baseline,composite){
  const {width,height}=baseline;
  if(!dimensionsValid(width,height)||width*REFERENCE.height!==height*REFERENCE.width||
    composite.width!==width||composite.height!==height||
    baseline.data.length!==width*height*4||composite.data.length!==width*height*4){
    throw new Error('Pixel audit requires matching ImageData in the original aspect ratio');
  }
  let protectedPixels=0,changedProtectedPixels=0,maxProtectedChannelDifference=0;
  const alpha=alphaPixels(width,height);
  for(let y=0;y<height;y++)for(let x=0;x<width;x++){
    if(alpha[y*width+x]!==0)continue;
    protectedPixels++;
    const index=(y*width+x)*4;
    let difference=0;
    for(let channel=0;channel<4;channel++)difference=Math.max(difference,Math.abs(baseline.data[index+channel]-composite.data[index+channel]));
    if(difference)changedProtectedPixels++;
    maxProtectedChannelDifference=Math.max(maxProtectedChannelDifference,difference);
  }
  return {pass:changedProtectedPixels===0,protectedPixels,changedProtectedPixels,maxProtectedChannelDifference};
}
function createProtectedCompositor(canvas,original,{mapping='original',outputScale=1}={}){
  const nativeWidth=original.naturalWidth??original.width;
  const nativeHeight=original.naturalHeight??original.height;
  if(!dimensionsValid(nativeWidth,nativeHeight)||nativeWidth*REFERENCE.height!==nativeHeight*REFERENCE.width)throw new Error('Original aspect ratio mismatch');
  if(!Number.isFinite(outputScale)||outputScale<=0)throw new RangeError('Output scale must be a positive finite number');
  const width=nativeWidth*outputScale;
  const height=nativeHeight*outputScale;
  if(!dimensionsValid(width,height)||width*REFERENCE.height!==height*REFERENCE.width)throw new RangeError('Output scale must produce integer dimensions in the approved aspect ratio');
  if(!Object.hasOwn(FRAME_MAPPINGS,mapping))throw new Error('Unknown video mapping: '+mapping);
  canvas.width=width;canvas.height=height;
  const context=canvas.getContext('2d',{alpha:false});
  const scratch=document.createElement('canvas');scratch.width=width;scratch.height=height;
  const frameContext=scratch.getContext('2d');
  const matte=document.createElement('canvas');matte.width=width;matte.height=height;
  const matteContext=matte.getContext('2d');const data=matteContext.createImageData(width,height);
  const alpha=alphaPixels(width,height);
  for(let y=0;y<height;y++)for(let x=0;x<width;x++){
    const index=(y*width+x)*4;
    data.data[index]=data.data[index+1]=data.data[index+2]=255;
    data.data[index+3]=alpha[y*width+x];
  }
  matteContext.putImageData(data,0,0);
  const originalLayer=document.createElement('canvas');originalLayer.width=width;originalLayer.height=height;
  const originalContext=originalLayer.getContext('2d',{alpha:false,willReadFrequently:true});
  originalContext.drawImage(original,0,0,width,height);
  const originalOnly=()=>{context.globalCompositeOperation='source-over';context.drawImage(originalLayer,0,0);};
  originalOnly();
  return {
    originalOnly,
    draw(frame,{incoming,mix=0}={}){
      if(!Number.isFinite(mix)||mix<0||mix>1)throw new RangeError('Video mix must be a finite number from 0 to 1');
      if(incoming==null&&mix!==0)throw new Error('A nonzero video mix requires an incoming frame');
      const fw=frame.videoWidth??frame.naturalWidth??frame.width;
      const fh=frame.videoHeight??frame.naturalHeight??frame.height;
      const {sourceRect}=resolveFrameMapping(fw,fh,mapping);
      const incomingRect=incoming==null?null:resolveFrameMapping(
        incoming.videoWidth??incoming.naturalWidth??incoming.width,
        incoming.videoHeight??incoming.naturalHeight??incoming.height,
        mapping
      ).sourceRect;
      frameContext.globalCompositeOperation='source-over';frameContext.globalAlpha=1;frameContext.clearRect(0,0,width,height);
      if(mix<1)frameContext.drawImage(frame,sourceRect.x,sourceRect.y,sourceRect.width,sourceRect.height,0,0,width,height);
      if(incomingRect&&mix>0){
        frameContext.globalAlpha=mix;
        frameContext.drawImage(incoming,incomingRect.x,incomingRect.y,incomingRect.width,incomingRect.height,0,0,width,height);
      }
      frameContext.globalAlpha=1;
      frameContext.globalCompositeOperation='destination-in';frameContext.drawImage(matte,0,0);
      originalOnly();context.drawImage(scratch,0,0);
    },
    dispose(){scratch.width=scratch.height=matte.width=matte.height=originalLayer.width=originalLayer.height=1;}
  };
}

function initialize(controls){


const section=document.querySelector('#crisp-top');
if(!section||controls.dataset.waterBound==='true'||section.hhWaterFilmDispose)return;
controls.dataset.waterBound='true';
let destroyed=false;
const lifetime=new AbortController();
const on=(target,event,callback,options={})=>target.addEventListener(event,callback,{...options,signal:lifetime.signal});
const text=key=>controls.dataset[key];
const status=controls.querySelector('[data-water-status]');
const playButton=controls.querySelector('[data-water-play]');
const pauseButton=controls.querySelector('[data-water-pause]');
const stillButton=controls.querySelector('[data-water-still]');
const desktop=matchMedia('(min-width: 768px)');
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
const canvas=document.createElement('canvas');
canvas.className='hh-water-film-canvas';canvas.hidden=true;canvas.setAttribute('aria-hidden','true');
section.append(canvas);
const video=document.createElement('video');
video.muted=true;video.defaultMuted=true;video.playsInline=true;video.loop=false;
video.preload='none';video.hidden=true;video.crossOrigin='anonymous';video.setAttribute('aria-hidden','true');
document.body.append(video);
const incomingVideo=video.cloneNode();
incomingVideo.muted=true;incomingVideo.defaultMuted=true;incomingVideo.crossOrigin='anonymous';document.body.append(incomingVideo);
for(const movie of [video,incomingVideo]){movie.defaultPlaybackRate=.65;movie.playbackRate=.65;}
const image=new Image();image.crossOrigin='anonymous';
let compositor,ready=false,failed=false,starting=false,inView=true,frameHandle=0;
let intent=reduced.matches?'original':'playing';
let loops=0,rendered=0,active=video,standby=incomingVideo,frameOwner=video,blending=false;
const overlap=.85;

function setStatus(message){status.textContent=message;}
function refreshControls(){
  playButton.disabled=failed||!desktop.matches;
  pauseButton.disabled=!ready||intent!=='playing';
  playButton.setAttribute('aria-pressed',String(intent==='playing'&&!canvas.hidden));
  stillButton.setAttribute('aria-pressed',String(canvas.hidden));
}
function cancelFrame(){
  if(!frameHandle)return;
  if(frameOwner.cancelVideoFrameCallback)frameOwner.cancelVideoFrameCallback(frameHandle);
  else cancelAnimationFrame(frameHandle);
  frameHandle=0;
}
function stop(){cancelFrame();video.pause();incomingVideo.pause();}
function original(){
  intent='original';stop();canvas.hidden=true;
  setStatus(desktop.matches?text('staticStatus'):text('mobileStatus'));refreshControls();
}
function fail(error){
  if(destroyed)return;
  failed=true;stop();canvas.hidden=true;
  setStatus(text('failureStatus'));refreshControls();
  console.warn('Water film fallback:',error instanceof Error?error.message:String(error));
}
function draw(){
  if(!ready||failed||active.readyState<2)return;
  if(active.currentTime>=active.duration-overlap&&standby.readyState>=2){
    if(!blending){
      blending=true;
      standby.play().catch(error=>{if(error.name!=='AbortError')fail(error);});
    }
    const t=Math.max(0,Math.min(1,(active.currentTime-(active.duration-overlap))/overlap));
    const mix=t*t*(3-2*t);
    compositor.draw(active,{incoming:standby,mix});
    canvas.dataset.loopBlend=mix.toFixed(3);
  }else{compositor.draw(active);canvas.dataset.loopBlend='0';}
  canvas.hidden=false;rendered++;
  canvas.dataset.frames=String(rendered);canvas.dataset.loops=String(loops);
  canvas.dataset.videoTime=active.currentTime.toFixed(3);
}
function switchLoop(ended){
  if(ended!==active||failed||intent!=='playing')return;
  cancelFrame();
  const previous=active;active=standby;standby=previous;
  standby.pause();standby.currentTime=0;blending=false;loops++;
  resume();
}
on(video,'ended',()=>switchLoop(video));
on(incomingVideo,'ended',()=>switchLoop(incomingVideo));
function schedule(){
  cancelFrame();
  const tick=()=>{
    frameHandle=0;
    if(intent!=='playing'||active.paused||document.hidden||!inView||!desktop.matches)return;
    try{draw();schedule();}catch(error){fail(error);}
  };
  frameOwner=active;
  frameHandle=active.requestVideoFrameCallback?active.requestVideoFrameCallback(tick):requestAnimationFrame(tick);
}
async function resume(){
  if(destroyed||!ready||failed||intent!=='playing'||!desktop.matches||document.hidden||!inView)return;
  try{
    await active.play();
    if(blending)await standby.play();
    if(intent!=='playing'||!desktop.matches||document.hidden||!inView){stop();return;}
    draw();schedule();setStatus(text('playingStatus'));refreshControls();
  }catch(error){
    if(error.name==='AbortError'){refreshControls();return;}
    if(error.name==='NotAllowedError'){
      stop();canvas.hidden=true;setStatus(text('clickStatus'));refreshControls();
    }else fail(error);
  }
}
async function prepare(){
  if(destroyed||starting||ready||failed||intent!=='playing'||!desktop.matches)return;
  starting=true;setStatus(text('loadingStatus'));
  try{
    const sourceUrl=new URL(controls.dataset.videoUrl,document.baseURI);
    const stillUrl=new URL(controls.dataset.stillUrl,document.baseURI);
    const pageUrl=new URL(document.baseURI);
    const approvedStillHost=stillUrl.hostname==='cdn.shopify.com'||stillUrl.origin===pageUrl.origin;
    const approvedStillFile=stillUrl.pathname.endsWith('/hh-683ef1556b-home-hero-2547w.webp');
    if(sourceUrl.protocol!=='https:'||sourceUrl.hostname!=='cdn.shopify.com'||stillUrl.protocol!=='https:'||!approvedStillHost||!approvedStillFile)throw Error('Unregistered media source');
    image.src=stillUrl.href;
    const imageReady=image.decode();
    const movieReady=movie=>new Promise((resolve,reject)=>{
      const timer=setTimeout(()=>reject(Error('Video load timeout')),20000);
      on(movie,'loadeddata',()=>{clearTimeout(timer);resolve();},{once:true});
      on(movie,'error',()=>{clearTimeout(timer);reject(Error('Video decode failed'));},{once:true});
      lifetime.signal.addEventListener('abort',()=>{clearTimeout(timer);reject(new DOMException('Section removed','AbortError'));},{once:true});
    });
    const moviesReady=Promise.all([movieReady(video),movieReady(incomingVideo)]);
    for(const movie of [video,incomingVideo]){
      movie.crossOrigin='anonymous';movie.preload='auto';movie.src=sourceUrl.href;movie.load();movie.defaultPlaybackRate=.65;movie.playbackRate=.65;
    }
    await Promise.all([imageReady,moviesReady]);
    if(destroyed)return;
    if(image.naturalWidth!==2547||image.naturalHeight!==1671)throw Error('Original dimensions mismatch');
    compositor=createProtectedCompositor(canvas,image,{mapping:'runway-padded-4x3',outputScale:4/3});
    ready=true;refreshControls();
    if(intent==='playing')await resume();
    else setStatus(text('staticStatus'));
  }catch(error){fail(error);}
}
on(playButton,'click',async()=>{
  intent='playing';
  if(!ready)await prepare();else await resume();
});
on(pauseButton,'click',()=>{
  intent='paused';stop();setStatus(text('pausedStatus'));refreshControls();
});
on(stillButton,'click',original);
on(video,'error',()=>{if(starting)fail(Error('Video unavailable'));});
on(incomingVideo,'error',()=>{if(starting)fail(Error('Incoming video unavailable'));});
const observer=new IntersectionObserver(([entry])=>{
  inView=entry.isIntersecting;
  if(inView)resume();else stop();
},{threshold:0});
observer.observe(section);
on(document,'visibilitychange',()=>document.hidden?stop():resume());
on(desktop,'change',()=>{
  if(!desktop.matches){stop();canvas.hidden=true;setStatus(text('mobileStatus'));}
  else if(intent==='playing'){prepare();resume();}
  else setStatus(text('staticStatus'));
  refreshControls();
});
on(reduced,'change',()=>{if(reduced.matches)original();});
on(window,'pagehide',()=>stop());
on(window,'pageshow',()=>resume());
refreshControls();
if(desktop.matches&&!reduced.matches)prepare();
else setStatus(desktop.matches?text('reducedStatus'):text('mobileStatus'));

section.hhWaterFilmDispose=()=>{
  destroyed=true;stop();observer.disconnect();lifetime.abort();
  for(const movie of [video,incomingVideo]){movie.removeAttribute('src');movie.load();movie.remove();}
  compositor?.dispose();canvas.remove();delete controls.dataset.waterBound;
  delete section.hhWaterFilmDispose;
};

}
function boot(){document.querySelectorAll('[data-hh-water-film]').forEach(initialize);}
boot();
document.addEventListener('shopify:section:load',boot);
document.addEventListener('shopify:section:unload',event=>{
  const hero=document.querySelector('#crisp-top');
  if(hero&&(event.target.contains(hero)||event.target.querySelector('[data-hh-water-film]')))hero.hhWaterFilmDispose?.();
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-water-live"]) return;
  try {
    
(()=>{
const PRODUCT_OUTLINE = [
  [429,342.7],[433.7,342],[440.3,344.3],[462,352.7],
  [482,360.3],[490.3,362.7],[495,367.3],[498.7,375],
  [503.3,388],[507,402.3],[509,414.3],[508,422],
  [503.3,430.3],[496.3,442.3],[488,454.3],[480.3,466.7],
  [473.3,478],[468.7,482.7],[463.3,485],[457.7,485],
  [449,482],[439,478],[409,465],[390,455],[385,450],
  [382,443],[381.7,436],[384,424],[391,404],[395,393],
  [419,351],[424,345]
];

function productDistance(x,y){
  if(x<379||x>512||y<339||y>488)return 99;
  let inside=false,dist2=Infinity;
  for(let i=0,j=PRODUCT_OUTLINE.length-1;i<PRODUCT_OUTLINE.length;j=i++){
    const [ax,ay]=PRODUCT_OUTLINE[j],[bx,by]=PRODUCT_OUTLINE[i];
    if(((ay>y)!==(by>y))&&x<(bx-ax)*(y-ay)/(by-ay)+ax)inside=!inside;
    const dx=bx-ax,dy=by-ay,t=Math.max(0,Math.min(1,((x-ax)*dx+(y-ay)*dy)/(dx*dx+dy*dy)));
    dist2=Math.min(dist2,(x-ax-t*dx)**2+(y-ay-t*dy)**2);
  }
  return (inside?-1:1)*Math.sqrt(dist2);
}


const PAPER_EDGE = Object.freeze([
  [463.067,0], [463.4,1], [463.733,2], [464.067,3], [464.067,4], [464.067,5], [464.733,6], [466.4,7],
  [466.4,8], [466.4,9], [465.733,10], [465.4,11], [465.067,12], [464.733,13], [464.4,14], [462.067,15],
  [462.067,16], [462.067,17], [461.733,18], [464.733,19], [464.733,20], [465.067,21], [465.067,22], [465.4,23],
  [466.067,24], [466.4,25], [467.4,26], [467.4,27], [467.067,28], [466.4,29], [466.4,30], [467.067,31],
  [467.067,32], [467.067,33], [467.067,34], [467.067,35], [469.067,36], [469.4,37], [469.733,38], [470.067,39],
  [469.733,40], [469.733,41], [470.067,42], [470.4,43], [470.4,44], [470.067,45], [469.4,46], [469.4,47],
  [469.733,48], [469.733,49], [469.4,50], [468.733,51], [468.733,52], [468.4,53], [467.733,54], [467.4,55],
  [467.067,56], [467.4,57], [467.4,58], [467.733,59], [467.733,60], [467.4,61], [466.4,62], [465.4,63],
  [465.067,64], [464.733,65], [464.4,66], [464.4,67], [464.067,68], [463.733,69], [463.4,70], [463.067,71],
  [463.067,72], [463.067,73], [463.067,74], [463.067,75], [463.4,76], [463.733,77], [463.733,78], [464.067,79],
  [464.067,80], [463.733,81], [463.733,82], [463.4,83], [463.4,84], [463.067,85], [462.4,86], [462.067,87],
  [461.4,88], [460.733,89], [457.5,90], [457.4,91], [457.067,92], [456.733,93], [456.4,94], [456.4,95],
  [456.067,96], [456.067,97], [456.733,98], [456.733,99], [456.733,100], [457.067,101], [457.067,102], [457.4,103],
  [457.067,104], [456.733,105], [456.067,106], [455.4,107], [455.067,108], [455.067,109], [455.733,110], [456.067,111],
  [456.067,112], [455.4,113], [454.4,114], [453.733,115], [453.733,116], [453.733,117], [453.733,118], [453.4,119],
  [453.4,120], [453.4,121], [453.067,122], [453.067,123], [453.067,124], [453.067,125], [453.067,126], [453.067,127],
  [452.733,128], [452.733,129], [450.067,130], [452.733,131], [453.067,132], [453.4,133], [453.733,134], [454.067,135],
  [455.067,136], [455.733,137], [456.4,138], [456.4,139], [456.4,140], [456.733,141], [457.4,142], [457.4,143],
  [456.4,144], [456.067,145], [456.4,146], [457.4,147], [458.4,148], [458.733,149], [458.733,150], [458.4,151],
  [458.733,152], [458.4,153], [457.4,154], [457.4,155], [457.733,156], [457.733,157], [457.4,158], [457.067,159],
  [457.067,160], [457.067,161], [457.4,162], [458.067,163], [458.067,164], [457.733,165], [457.733,166], [458.4,167],
  [458.733,168], [458.733,169], [458.4,170], [458.4,171], [458.733,172], [459.4,173], [460.067,174], [460.733,175],
  [461.067,176], [460.733,177], [461.067,178], [461.733,179], [462.4,180], [462.733,181], [463.067,182], [463.067,183],
  [463.4,184], [462.733,185], [462.4,186], [462.4,187], [462.4,188], [462.4,189], [462.733,190], [462.4,191],
  [461.733,192], [461.067,193], [460.4,194], [460.4,195], [460.4,196], [460.4,197], [460.4,198], [460.067,199],
  [459.4,200], [458.733,201], [458.4,202], [458.733,203], [459.4,204], [459.4,205], [459.067,206], [457.733,207],
  [457.067,208], [456.733,209], [456.4,210], [456.4,211], [456.4,212], [456.733,213], [457.4,214], [458.067,215],
  [458.733,216], [458.733,217], [457.733,218], [457.067,219], [456.733,220], [457.067,221], [457.4,222], [458.067,223],
  [458.067,224], [457.733,225], [457.4,226], [457.4,227], [457.067,228], [457.067,229], [456.733,230], [456.4,231],
  [456.067,232], [455.4,233], [454.733,234], [454.4,235], [455.067,236], [455.733,237], [456.4,238], [456.4,239],
  [456.4,240], [456.067,241], [453.733,242], [453.733,243], [453.4,244], [453.067,245], [452.733,246], [452.733,247],
  [452.733,248], [453.067,249], [453.4,250], [453.067,251], [452.733,252], [452.4,253], [452.733,254], [453.067,255],
  [453.067,256], [452.733,257], [451.733,258], [451.067,259], [450.733,260], [450.733,261], [450.733,262], [451.067,263],
  [451.4,264], [452.067,265], [452.067,266], [451.733,267], [451.067,268], [450.733,269], [450.4,270], [450.4,271],
  [450.733,272], [451.4,273], [452.067,274], [452.4,275], [452.4,276], [452.067,277], [452.4,278], [452.733,279],
  [453.067,280], [453.4,281], [453.733,282], [454.4,283], [454.4,284], [454.4,285], [453.733,286], [453.4,287],
  [454.067,288], [454.733,289], [455.067,290], [455.067,291], [454.733,292], [454.4,293], [454.4,294], [455.067,295],
  [455.4,296], [456.067,297], [456.733,298], [457.4,299], [457.733,300], [457.067,301], [457.067,302], [457.4,303],
  [457.733,304], [457.4,305], [457.733,306], [458.067,307], [458.067,308], [458.067,309], [458.067,310], [458.4,311],
  [459.067,312], [459.4,313], [459.4,314], [459.4,315], [459.067,316], [458.733,317], [459.733,318], [460.067,319],
  [460.4,320], [460.733,321], [461.067,322], [461.067,323], [461.067,324], [461.067,325], [461.067,326], [460.733,327],
  [460.733,328], [460.4,329], [459.733,330], [460.4,331], [460.4,332], [460.4,333], [460.4,334], [460.733,335],
  [460.733,336], [461.067,337], [461.4,338], [461.4,339], [461.4,340], [461.4,341], [461.733,342], [461.4,343],
  [461.733,344], [461.733,345], [462.067,346], [462.4,347], [463.067,348], [463.733,349], [463.067,350], [462.4,351],
  [462.067,352], [462.4,353], [463.067,354], [463.067,486], [463.067,487], [463.4,488], [463.733,489], [462.733,490],
  [462.4,491], [462.4,492], [462.733,493], [462.4,494], [462.4,495], [462.733,496], [462.733,497], [462.733,498],
  [462.733,499], [462.4,500], [462.4,501], [462.4,502], [462.4,503], [462.4,504], [462.4,505], [462.4,506],
  [462.4,507], [462.067,508], [462.067,509], [462.067,510], [462.4,511], [462.4,512], [462.733,513], [463.733,514],
  [463.733,515], [463.067,516], [463.067,517], [462.733,518], [462.733,519], [462.733,520], [462.4,521], [462.4,522],
  [462.4,523], [462.4,524], [462.4,525], [462.4,526], [462.733,527], [462.733,528], [462.733,529], [462.733,530],
  [462.733,531], [462.733,532], [462.733,533], [463.067,534], [463.067,535], [462.733,536], [462.4,537], [462.733,538],
  [462.733,539], [462.733,540], [462.733,541], [462.733,542], [462.733,543], [462.733,544], [462.733,545], [462.733,546],
  [463.067,547], [463.733,548], [463.733,549], [463.733,550], [463.733,551], [463.733,552], [463.733,553], [463.733,554],
  [463.733,555], [463.733,556], [463.733,557],
].map(point => Object.freeze(point)));

const BOTTOM_EDGE = Object.freeze([
  [462,557], [463,557], [464,557], [465,557], [466,557], [467,556.667], [468,556.333], [469,556],
  [470,556], [471,556.667], [472,556.667], [473,556.667], [474,556.667], [475,556.667], [476,556.667], [477,556.667],
  [478,557], [479,557], [480,556.667], [481,556.333], [482,556], [483,556.667], [484,556.667], [485,555.667],
  [486,556.667], [487,556.667], [488,556], [489,556.667], [490,556.667], [491,556.667], [492,557], [493,557],
  [494,557], [495,557], [496,556.667], [497,556.667], [498,556.667], [499,556.667], [500,556.667], [501,557],
  [502,557], [503,557], [504,557], [505,557], [506,557], [507,557], [508,557], [509,556.667],
  [510,556.333], [511,556.667], [512,557], [513,557], [514,557], [515,556.667], [516,557], [517,557],
  [518,557], [519,556.667], [520,556.667], [521,556.667], [522,556.667], [523,556.667], [524,557], [525,557],
  [526,557], [527,557], [528,557], [529,557], [530,557], [531,557], [532,557], [533,557],
  [534,557], [535,556.667], [536,556.333], [537,556], [538,555.667], [539,555.333], [540,556], [541,556.333],
  [542,556.333], [543,556.667], [544,557], [545,556.667], [546,556.667], [547,556.667], [548,556.667], [549,556.333],
  [550,556], [551,555.333], [552,555.333], [553,556], [554,556.333], [555,556.333], [556,556.667], [557,557],
  [558,557], [559,557], [560,556.667], [561,556.667], [562,556.667], [563,556.333], [564,556.333], [565,556],
  [566,555.333], [567,555.667], [568,556], [569,556], [570,556.667], [571,557], [572,557], [573,557],
  [574,557], [575,557], [576,557], [577,557], [578,557], [579,557], [580,557], [581,557],
  [582,557], [583,557], [584,557], [585,557], [586,556.667], [587,556.667], [588,556.667], [589,556.333],
  [590,555.333], [591,555.333], [592,555.333], [593,555.333], [594,555.333], [595,555.333], [596,555.333], [597,555.333],
  [598,555.333], [599,555.667], [600,556], [601,556], [602,556.333], [603,557], [604,557], [605,557],
  [606,557], [607,556.333], [608,556.333], [609,556.333], [610,556], [611,555.667], [612,556], [613,556.333],
  [614,556], [615,556], [616,556], [617,556], [618,556.333], [619,556.333], [620,556.333], [621,556.667],
  [622,557], [623,557], [624,557], [625,556.333], [626,556], [627,556], [628,556], [629,556.333],
  [630,556.667], [631,557], [632,557], [633,556.333], [634,556], [635,556], [636,556], [637,556],
  [638,556], [639,556], [640,556], [641,556.333], [642,556], [643,556], [644,555.333], [645,555.667],
  [646,556.333], [647,556.333], [648,556], [649,555.667], [650,555.333], [651,555.333], [652,556.667], [653,556],
  [654,556], [655,556.333], [656,556], [657,555.667], [658,555.667], [659,556.667], [660,556.667], [661,556.667],
  [662,556.667], [663,556.667], [664,556.667], [665,556], [666,556], [667,556.333], [668,556.333], [669,556.333],
  [670,556.333], [671,557], [672,557], [673,557], [674,557], [675,557], [676,557], [677,557],
  [678,557], [679,557], [680,556.667], [681,555.333], [682,555.333], [683,555.333], [684,556], [685,556],
  [686,556.667], [687,557], [688,557], [689,557], [690,557], [691,557], [692,557], [693,557],
  [694,557], [695,557], [696,557], [697,557], [698,556.667], [699,556.667], [700,556.333], [701,556.333],
  [702,556], [703,556], [704,556], [705,556], [706,555.667], [707,555.333], [708,555.667], [709,556],
  [710,556], [711,556], [712,555.333], [713,555.333], [714,555.333], [715,555.333], [716,555.667], [717,555.667],
  [718,556], [719,556], [720,556.333], [721,556.667], [722,556.667], [723,556.333], [724,556], [725,556],
  [726,556], [727,556], [728,556], [729,556], [730,555.667], [731,555.333], [732,555.333], [733,556.667],
  [734,556.667], [735,556.667], [736,556.667], [737,556.667], [738,555.333], [739,555.333], [740,556.667], [741,556.667],
  [742,556], [743,556], [744,556], [745,556], [746,556], [747,555.667], [748,555.333], [749,556.667],
  [750,556.667], [751,556.667], [752,556.667], [753,556.667], [754,556.667], [755,556.667], [756,556], [757,556],
  [758,556], [759,556.333], [760,556.333], [761,556], [762,555.333], [763,556.667], [764,556.667], [765,556.667],
  [766,556.667], [767,557], [768,557], [769,557], [770,557], [771,557], [772,557], [773,557],
  [774,557], [775,557], [776,557], [777,556.667], [778,556.667], [779,556.667], [780,556.667], [781,556.667],
  [782,556.667], [783,557], [784,557], [785,557], [786,556.667], [787,556.667], [788,556.667], [789,557],
  [790,557], [791,557], [792,557], [793,557], [794,557], [795,557], [796,557], [797,557],
  [798,556.667], [799,557], [800,557], [801,557], [802,557], [803,556.667], [804,556.333], [805,556.333],
  [806,556.667], [807,557], [808,557], [809,557], [810,556.667], [811,556.667], [812,556.667], [813,556.667],
  [814,556.667], [815,557], [816,557], [817,557], [818,557], [819,557], [820,557], [821,557],
  [822,557], [823,557], [824,556.667], [825,556.333], [826,556.333], [827,556.333], [828,556.333], [829,556.667],
  [830,556.667], [831,556.667], [832,556.667], [833,556.333], [834,556.333], [835,556.333], [836,556.333], [837,557],
  [838,557], [839,557], [840,557], [841,557], [842,556.667], [843,556.667], [844,556.667], [845,556.667],
  [846,557], [847,557], [848,557], [849,557],
].map(point => Object.freeze(point)));


const REFERENCE={width:849,height:557,sha256:'683ef1556beb7d3a35df10dcf0d84d87c5b08575d1e647abf1a01271c4200d54'};
const FRAME_MAPPINGS=Object.freeze({
  original:Object.freeze({
    width:849,height:557,
    sourceRect:Object.freeze({x:0,y:0,width:849,height:557}),
    description:'Full approved 849:557 artwork, with no padding or crop.'
  }),
  'runway-padded-4x3':Object.freeze({
    width:2548,height:1911,
    sourceRect:Object.freeze({x:0,y:120,width:2547,height:1671}),
    description:'Known 4:3 transport: remove 120 source pixels above/below and one at the right; keep the approved 2547 x 1671 artwork.'
  })
});
const dimensionsValid=(width,height)=>Number.isSafeInteger(width)&&Number.isSafeInteger(height)&&width>0&&height>0;
function resolveFrameMapping(width,height,mapping='original'){
  if(!Object.hasOwn(FRAME_MAPPINGS,mapping))throw new Error('Unknown video mapping: '+mapping);
  if(!dimensionsValid(width,height))throw new Error('Frame not decoded or invalid dimensions');
  const definition=FRAME_MAPPINGS[mapping];
  if(width*definition.height!==height*definition.width)throw new Error('Video framing requires registration for mapping '+mapping);
  const scale=width/definition.width;
  return {
    mapping,
    description:definition.description,
    sourceRect:{
      x:definition.sourceRect.x*scale,
      y:definition.sourceRect.y*scale,
      width:definition.sourceRect.width*scale,
      height:definition.sourceRect.height*scale
    }
  };
}
const smooth=(a,b,v)=>{const t=Math.max(0,Math.min(1,(v-a)/(b-a)));return t*t*(3-2*t);};
function interpolate(points,v,axis){
  let low=0,high=points.length-1;
  if(v<=points[low][axis])return points[low][1-axis];
  if(v>=points[high][axis])return points[high][1-axis];
  while(high-low>1){const mid=(low+high)>>1;if(points[mid][axis]>v)high=mid;else low=mid;}
  const a=points[low],b=points[high],t=(v-a[axis])/(b[axis]-a[axis]);
  return a[1-axis]+t*(b[1-axis]-a[1-axis]);
}
function waterAlpha(x,y){
  if(x<0||y<0||x>=REFERENCE.width||y>=REFERENCE.height)return 0;
  const paperEdge=interpolate(PAPER_EDGE,y,1);
  if(x<=paperEdge)return 0;
  const bottomEdge=interpolate(BOTTOM_EDGE,x,0);
  if(y>=bottomEdge)return 0;
  return smooth(0,.65,x-paperEdge)
    *smooth(0,.65,bottomEdge-y)
    *smooth(0,.65,productDistance(x,y));
}
const alphaCache=new Map();
function alphaPixels(width,height){
  const key=width+'x'+height;
  if(alphaCache.has(key))return alphaCache.get(key);
  const alpha=new Uint8ClampedArray(width*height);
  for(let y=0;y<height;y++)for(let x=0;x<width;x++)alpha[y*width+x]=Math.round(waterAlpha((x+.5)*849/width,(y+.5)*557/height)*255);
  if(alphaCache.size>=2)alphaCache.clear();
  alphaCache.set(key,alpha);return alpha;
}
function auditProtectedPixels(baseline,composite){
  const {width,height}=baseline;
  if(!dimensionsValid(width,height)||width*REFERENCE.height!==height*REFERENCE.width||
    composite.width!==width||composite.height!==height||
    baseline.data.length!==width*height*4||composite.data.length!==width*height*4){
    throw new Error('Pixel audit requires matching ImageData in the original aspect ratio');
  }
  let protectedPixels=0,changedProtectedPixels=0,maxProtectedChannelDifference=0;
  const alpha=alphaPixels(width,height);
  for(let y=0;y<height;y++)for(let x=0;x<width;x++){
    if(alpha[y*width+x]!==0)continue;
    protectedPixels++;
    const index=(y*width+x)*4;
    let difference=0;
    for(let channel=0;channel<4;channel++)difference=Math.max(difference,Math.abs(baseline.data[index+channel]-composite.data[index+channel]));
    if(difference)changedProtectedPixels++;
    maxProtectedChannelDifference=Math.max(maxProtectedChannelDifference,difference);
  }
  return {pass:changedProtectedPixels===0,protectedPixels,changedProtectedPixels,maxProtectedChannelDifference};
}
function createProtectedCompositor(canvas,original,{mapping='original',outputScale=1}={}){
  const nativeWidth=original.naturalWidth??original.width;
  const nativeHeight=original.naturalHeight??original.height;
  if(!dimensionsValid(nativeWidth,nativeHeight)||nativeWidth*REFERENCE.height!==nativeHeight*REFERENCE.width)throw new Error('Original aspect ratio mismatch');
  if(!Number.isFinite(outputScale)||outputScale<=0)throw new RangeError('Output scale must be a positive finite number');
  const width=nativeWidth*outputScale;
  const height=nativeHeight*outputScale;
  if(!dimensionsValid(width,height)||width*REFERENCE.height!==height*REFERENCE.width)throw new RangeError('Output scale must produce integer dimensions in the approved aspect ratio');
  if(!Object.hasOwn(FRAME_MAPPINGS,mapping))throw new Error('Unknown video mapping: '+mapping);
  canvas.width=width;canvas.height=height;
  const context=canvas.getContext('2d',{alpha:false});
  const scratch=document.createElement('canvas');scratch.width=width;scratch.height=height;
  const frameContext=scratch.getContext('2d');
  const matte=document.createElement('canvas');matte.width=width;matte.height=height;
  const matteContext=matte.getContext('2d');const data=matteContext.createImageData(width,height);
  const alpha=alphaPixels(width,height);
  for(let y=0;y<height;y++)for(let x=0;x<width;x++){
    const index=(y*width+x)*4;
    data.data[index]=data.data[index+1]=data.data[index+2]=255;
    data.data[index+3]=alpha[y*width+x];
  }
  matteContext.putImageData(data,0,0);
  const originalLayer=document.createElement('canvas');originalLayer.width=width;originalLayer.height=height;
  const originalContext=originalLayer.getContext('2d',{alpha:false,willReadFrequently:true});
  originalContext.drawImage(original,0,0,width,height);
  const originalOnly=()=>{context.globalCompositeOperation='source-over';context.drawImage(originalLayer,0,0);};
  originalOnly();
  return {
    originalOnly,
    draw(frame,{incoming,mix=0}={}){
      if(!Number.isFinite(mix)||mix<0||mix>1)throw new RangeError('Video mix must be a finite number from 0 to 1');
      if(incoming==null&&mix!==0)throw new Error('A nonzero video mix requires an incoming frame');
      const fw=frame.videoWidth??frame.naturalWidth??frame.width;
      const fh=frame.videoHeight??frame.naturalHeight??frame.height;
      const {sourceRect}=resolveFrameMapping(fw,fh,mapping);
      const incomingRect=incoming==null?null:resolveFrameMapping(
        incoming.videoWidth??incoming.naturalWidth??incoming.width,
        incoming.videoHeight??incoming.naturalHeight??incoming.height,
        mapping
      ).sourceRect;
      frameContext.globalCompositeOperation='source-over';frameContext.globalAlpha=1;frameContext.clearRect(0,0,width,height);
      if(mix<1)frameContext.drawImage(frame,sourceRect.x,sourceRect.y,sourceRect.width,sourceRect.height,0,0,width,height);
      if(incomingRect&&mix>0){
        frameContext.globalAlpha=mix;
        frameContext.drawImage(incoming,incomingRect.x,incomingRect.y,incomingRect.width,incomingRect.height,0,0,width,height);
      }
      frameContext.globalAlpha=1;
      frameContext.globalCompositeOperation='destination-in';frameContext.drawImage(matte,0,0);
      originalOnly();context.drawImage(scratch,0,0);
    },
    dispose(){scratch.width=scratch.height=matte.width=matte.height=originalLayer.width=originalLayer.height=1;}
  };
}

function initialize(config){
const section=document.querySelector('#crisp-top');
if(!section||config.dataset.waterBound==='true'||section.hhWaterFilmDispose||section.hhWaterLiveDispose)return;
config.dataset.waterBound='true';
let destroyed=false;
const lifetime=new AbortController();
const on=(target,event,callback,options={})=>target.addEventListener(event,callback,{...options,signal:lifetime.signal});
const owner=config.parentElement;
const desktop=matchMedia('(min-width: 768px)');
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
const canvas=document.createElement('canvas');
canvas.className='hh-water-film-canvas';canvas.hidden=true;canvas.setAttribute('aria-hidden','true');
section.append(canvas);
const video=document.createElement('video');
video.muted=true;video.defaultMuted=true;video.playsInline=true;video.loop=false;
video.preload='none';video.hidden=true;video.crossOrigin='anonymous';video.setAttribute('aria-hidden','true');
document.body.append(video);
const incomingVideo=video.cloneNode();
incomingVideo.muted=true;incomingVideo.defaultMuted=true;incomingVideo.crossOrigin='anonymous';document.body.append(incomingVideo);
for(const movie of [video,incomingVideo]){movie.defaultPlaybackRate=.65;movie.playbackRate=.65;}
const image=new Image();image.crossOrigin='anonymous';
let compositor,ready=false,failed=false,starting=false,blocked=false,inView=true,frameHandle=0;
let resuming=false,playGeneration=0,policyRetries=0,pageActive=true;
let loops=0,rendered=0,active=video,standby=incomingVideo,frameOwner=video,blending=false;
const overlap=.85;
const eligible=()=>!destroyed&&!failed&&pageActive&&desktop.matches&&!reduced.matches&&!document.hidden&&inView;
function cancelFrame(){
  if(!frameHandle)return;
  if(frameOwner.cancelVideoFrameCallback)frameOwner.cancelVideoFrameCallback(frameHandle);
  else cancelAnimationFrame(frameHandle);
  frameHandle=0;
}
function stop(){playGeneration++;cancelFrame();video.pause();incomingVideo.pause();}
function fail(error){
  if(destroyed)return;
  failed=true;starting=false;stop();canvas.hidden=true;
  console.warn('Water film fallback:',error instanceof Error?error.message:String(error));
}
function draw(){
  if(!eligible()||!ready||active.readyState<2)return;
  if(active.currentTime>=active.duration-overlap&&standby.readyState>=2){
    if(!blending){
      blending=true;
      const blendingVideo=standby;
      blendingVideo.play().then(()=>{if(!eligible())blendingVideo.pause();}).catch(error=>{if(error.name!=='AbortError')fail(error);});
    }
    const t=Math.max(0,Math.min(1,(active.currentTime-(active.duration-overlap))/overlap));
    const mix=t*t*(3-2*t);
    compositor.draw(active,{incoming:standby,mix});
    canvas.dataset.loopBlend=mix.toFixed(3);
  }else{compositor.draw(active);canvas.dataset.loopBlend='0';}
  canvas.hidden=false;rendered++;
  canvas.dataset.frames=String(rendered);canvas.dataset.loops=String(loops);
  canvas.dataset.videoTime=active.currentTime.toFixed(3);
}
function switchLoop(ended){
  if(ended!==active||destroyed||failed)return;
  cancelFrame();
  const previous=active;active=standby;standby=previous;
  standby.pause();standby.currentTime=0;blending=false;loops++;
  resume();
}
on(video,'ended',()=>switchLoop(video));
on(incomingVideo,'ended',()=>switchLoop(incomingVideo));
function schedule(){
  cancelFrame();
  const tick=()=>{
    frameHandle=0;
    if(!eligible()||blocked||active.paused)return;
    try{draw();schedule();}catch(error){fail(error);}
  };
  frameOwner=active;
  frameHandle=active.requestVideoFrameCallback?active.requestVideoFrameCallback(tick):requestAnimationFrame(tick);
}
async function resume(){
  if(!eligible()||!ready||blocked||resuming)return;
  resuming=true;
  const generation=playGeneration;
  try{
    await active.play();
    if(blending)await standby.play();
    if(!eligible()){stop();return;}
    if(generation!==playGeneration)return;
    draw();schedule();
  }catch(error){
    if(destroyed)return;
    if(error.name==='AbortError')return;
    if(error.name==='NotAllowedError'){
      blocked=true;stop();canvas.hidden=true;
    }else fail(error);
  }finally{
    resuming=false;
    if(eligible()&&!blocked&&generation!==playGeneration)resume();
  }
}
async function prepare(){
  if(!eligible()||starting||ready)return;
  starting=true;
  try{
    const sourceUrl=new URL(config.dataset.videoUrl,document.baseURI);
    const stillUrl=new URL(config.dataset.stillUrl,document.baseURI);
    const pageUrl=new URL(document.baseURI);
    const approvedStillHost=stillUrl.hostname==='cdn.shopify.com'||stillUrl.origin===pageUrl.origin;
    const approvedStillFile=stillUrl.pathname.endsWith('/hh-683ef1556b-home-hero-2547w.webp');
    if(sourceUrl.protocol!=='https:'||sourceUrl.hostname!=='cdn.shopify.com'||stillUrl.protocol!=='https:'||!approvedStillHost||!approvedStillFile)throw Error('Unregistered media source');
    image.src=stillUrl.href;
    const imageReady=image.decode();
    const movieReady=movie=>new Promise((resolve,reject)=>{
      const timer=setTimeout(()=>reject(Error('Video load timeout')),20000);
      on(movie,'loadeddata',()=>{clearTimeout(timer);resolve();},{once:true});
      on(movie,'error',()=>{clearTimeout(timer);reject(Error('Video decode failed'));},{once:true});
      lifetime.signal.addEventListener('abort',()=>{clearTimeout(timer);reject(new DOMException('Section removed','AbortError'));},{once:true});
    });
    const moviesReady=Promise.all([movieReady(video),movieReady(incomingVideo)]);
    for(const movie of [video,incomingVideo]){
      movie.crossOrigin='anonymous';movie.preload='auto';movie.src=sourceUrl.href;movie.load();movie.defaultPlaybackRate=.65;movie.playbackRate=.65;
    }
    await Promise.all([imageReady,moviesReady]);
    if(destroyed)return;
    if(image.naturalWidth!==2547||image.naturalHeight!==1671)throw Error('Original dimensions mismatch');
    compositor=createProtectedCompositor(canvas,image,{mapping:'runway-padded-4x3',outputScale:4/3});
    starting=false;ready=true;
    await resume();
  }catch(error){fail(error);}
}
function requestResume(retry=false){
  if(!eligible()||resuming)return;
  if(blocked){
    if(!retry||policyRetries>=3)return;
    policyRetries++;blocked=false;
  }
  if(ready)resume();else prepare();
}
function retryFromInteraction(event){
  if(event.isTrusted&&blocked)requestResume(true);
}
on(document,'pointerdown',retryFromInteraction,{passive:true});
on(document,'keydown',retryFromInteraction);
on(video,'error',()=>{if(starting||ready)fail(Error('Video unavailable'));});
on(incomingVideo,'error',()=>{if(starting||ready)fail(Error('Incoming video unavailable'));});
const observer=new IntersectionObserver(([entry])=>{
  inView=entry.isIntersecting;
  if(inView)requestResume();else stop();
},{threshold:0});
observer.observe(section);
on(document,'visibilitychange',()=>document.hidden?stop():requestResume(true));
on(desktop,'change',()=>{
  if(!desktop.matches){stop();canvas.hidden=true;}
  else requestResume(true);
});
on(reduced,'change',()=>{
  if(reduced.matches){stop();canvas.hidden=true;}
  else requestResume(true);
});
on(window,'pagehide',()=>{pageActive=false;stop();});
on(window,'pageshow',()=>{pageActive=true;requestResume(true);});
requestResume();
section.hhWaterLiveDispose=()=>{
  destroyed=true;stop();observer.disconnect();lifetime.abort();
  for(const movie of [video,incomingVideo]){movie.removeAttribute('src');movie.load();movie.remove();}
  compositor?.dispose();canvas.remove();delete config.dataset.waterBound;
  delete section.hhWaterLiveDispose;
};
on(document,'shopify:section:unload',event=>{
  if(event.target===owner||event.target.contains(section))section.hhWaterLiveDispose?.();
});
}
function boot(){document.querySelectorAll('[data-hh-water-live]').forEach(initialize);}
boot();
document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-water-motion-preview"]) return;
  try {
    
(() => {
  const setup = () => {
    const control = document.querySelector('[data-hh-water-controls]');
    const hero = document.querySelector('#crisp-top');
    const art = hero?.querySelector('img.hh-art');
    if (!control || !hero || !art || control.dataset.initialized) return;
    control.dataset.initialized = 'true';
    const motionButton = control.querySelector('[data-water-play]');
    const stillButton = control.querySelector('[data-water-still]');
    const status = control.querySelector('[data-water-status]');
    const desktop = matchMedia('(min-width: 768px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const canvas = document.createElement('canvas');
    canvas.className = 'hh-water-motion-layer';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.hidden = true;
    hero.querySelector('picture').after(canvas);
    let gl;
    let frame = 0;
    let animationTime = 0;
    let lastTick = 0;
    let enabled = false;
    let ready = false;
    let visible = true;
    let disposed = false;
    const stop = () => { cancelAnimationFrame(frame); frame = 0; lastTick = 0; };
    const setStatic = () => {
      enabled = false;
      stop();
      canvas.hidden = true;
      motionButton.setAttribute('aria-pressed', 'false');
      stillButton.setAttribute('aria-pressed', 'true');
      status.textContent = desktop.matches ? control.dataset.still : control.dataset.mobile;
    };
    const fail = () => {
      ready = false;
      setStatic();
      motionButton.disabled = true;
      status.textContent = control.dataset.unavailable;
    };
    let draw = () => {};
    const animate = timestamp => {
      frame = 0;
      if (!enabled || !ready || !visible || document.hidden || disposed) return;
      if (timestamp - lastTick >= 1000 / 30) {
        animationTime += lastTick ? Math.min((timestamp - lastTick) / 1000, 0.08) : 0;
        lastTick = timestamp;
        draw(animationTime);
      }
      frame = requestAnimationFrame(animate);
    };
    const resume = () => {
      if (enabled && ready && visible && !document.hidden && !frame) frame = requestAnimationFrame(animate);
    };
    const setMotion = () => {
      if (!ready || !desktop.matches) return;
      enabled = true;
      draw(animationTime);
      canvas.hidden = false;
      motionButton.setAttribute('aria-pressed', 'true');
      stillButton.setAttribute('aria-pressed', 'false');
      status.textContent = control.dataset.motion;
      resume();
    };
    motionButton.addEventListener('click', setMotion);
    stillButton.addEventListener('click', setStatic);
    const mediaChanged = () => {
      motionButton.disabled = !ready || !desktop.matches;
      if (!desktop.matches || reduced.matches || !enabled) setStatic();
    };
    desktop.addEventListener('change', mediaChanged);
    reduced.addEventListener('change', mediaChanged);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : resume());
    const intersection = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      visible ? resume() : stop();
    });
    intersection.observe(hero);
    canvas.addEventListener('webglcontextlost', event => { event.preventDefault(); fail(); });
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onerror = fail;
    image.onload = () => {
      if (disposed) return;
      try {
        gl = canvas.getContext('webgl', { alpha: true, antialias: false, premultipliedAlpha: false, powerPreference: 'low-power' });
        if (!gl) return fail();
        const compile = (type, source) => {
          const shader = gl.createShader(type);
          gl.shaderSource(shader, source);
          gl.compileShader(shader);
          if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error('Water shader unavailable');
          return shader;
        };
        const vertex = compile(gl.VERTEX_SHADER, 'attribute vec2 point; varying vec2 uv; void main(){uv=vec2((point.x+1.0)*0.5,(1.0-point.y)*0.5);gl_Position=vec4(point,0.0,1.0);}');
        const fragment = compile(gl.FRAGMENT_SHADER, `
          precision highp float;
          varying vec2 uv;
          uniform sampler2D source;
          uniform float time;
          float edge(float y) {
            float x = 468.0;
            x += -7.0 * smoothstep(50.0,125.0,y);
            x += -5.0 * smoothstep(125.0,180.0,y);
            x += -3.0 * smoothstep(205.0,265.0,y);
            x += 10.0 * smoothstep(265.0,345.0,y);
            return x;
          }
          void main() {
            vec2 p=uv*vec2(849.0,557.0);
            float water=smoothstep(edge(p.y)+5.0,edge(p.y)+27.0,p.x);
            water*=1.0-smoothstep(532.0,549.0,p.y);
            float protectedArea=length((p-vec2(482.0,441.0))/vec2(118.0,100.0));
            water*=smoothstep(1.0,1.48,protectedArea);
            if(water<0.001){gl_FragColor=vec4(0.0);return;}
            vec2 q=p*0.017;
            float t=time*0.48;
            vec2 flow=vec2(
              2.7*sin(q.y*1.02+q.x*0.42+t)+1.5*sin(q.x*1.7-q.y*0.6-t*0.77),
              2.2*cos(q.x*0.9-q.y*0.38+t*0.82)+1.35*sin(q.y*1.8+q.x*0.72+t*1.13)
            );
            flow+=vec2(0.8*sin(q.y*3.2+q.x*0.65+t*1.4),0.7*cos(q.x*2.7-q.y*0.5-t*1.2));
            float entrance=smoothstep(0.0,2.5,time);
            vec2 sampleUV=clamp(uv+flow*water*entrance/vec2(849.0,557.0),vec2(0.001),vec2(0.999));
            vec3 colour=texture2D(source,sampleUV).rgb;
            float luminance=dot(colour,vec3(0.2126,0.7152,0.0722));
            float light=sin(q.x*0.7+q.y*1.1+t*0.75)*0.016;
            colour+=light*smoothstep(0.55,0.94,luminance)*water*entrance;
            gl_FragColor=vec4(colour,water);
          }
        `);
        const program = gl.createProgram();
        gl.attachShader(program, vertex);
        gl.attachShader(program, fragment);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Water program unavailable');
        gl.useProgram(program);
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), gl.STATIC_DRAW);
        const point = gl.getAttribLocation(program, 'point');
        gl.enableVertexAttribArray(point);
        gl.vertexAttribPointer(point, 2, gl.FLOAT, false, 0, 0);
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
        gl.uniform1i(gl.getUniformLocation(program, 'source'), 0);
        const time = gl.getUniformLocation(program, 'time');
        draw = seconds => {
          const bounds = hero.getBoundingClientRect();
          const width = Math.min(2547, Math.round(bounds.width * Math.min(devicePixelRatio || 1, 2)));
          const height = Math.round(width * 557 / 849);
          if (width < 1) return;
          if (canvas.width !== width || canvas.height !== height) { canvas.width = width; canvas.height = height; }
          gl.viewport(0, 0, width, height);
          gl.uniform1f(time, seconds);
          gl.drawArrays(gl.TRIANGLES, 0, 6);
        };
        ready = true;
        mediaChanged();
        if (desktop.matches && !reduced.matches) setMotion(); else setStatic();
        window.addEventListener('pagehide', () => {
          disposed = true;
          stop();
          intersection.disconnect();
          gl.deleteTexture(texture);
          gl.deleteBuffer(buffer);
          gl.deleteProgram(program);
          gl.deleteShader(vertex);
          gl.deleteShader(fragment);
        }, { once: true });
      } catch { fail(); }
    };
    image.src = control.dataset.source;
    setStatic();
    status.textContent = desktop.matches ? control.dataset.loading : control.dataset.mobile;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true }); else setup();
})();


  } catch(e) { console.error(e); }
})();
})();
